import React, { useState, useEffect, useCallback} from 'react';
import { makeStyles } from '@material-ui/core';
import { useTheme, Dialog, DialogActions, DialogTitle, Button } from '@mui/material';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import { IoIosArrowDropleftCircle, IoIosArrowDroprightCircle, IoIosArrowForward } from 'react-icons/io';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import InstagramFeed  from 'react-ig-feed'
import 'react-ig-feed/dist/index.css'
import mainPath from '../utils/path';
import { setColorAll, setOrderAll, setPageAll } from '../redux/pageSlice';
import Popup from '../components/Popup';


const useStyles = makeStyles((theme)=>({
    mainSectionBlock:{
        padding:'235px 0 0 0',
        maxWidth: 1920,
        margin: '0px auto',
        fontFamily:[
            'Noto Sans KR'
        ],

        [theme.breakpoints.down(1025)]: {
            padding:'132px 0 0 0',
        },
    },
    row:{
        maxWidth:'1200px', 
        margin:'0 auto', 
        padding:'10px', 
    },
    article1:{
        position:'relative',
    },
    slide:{
        position:'relative',
    },
    slideImg:{
        maxHeight:'378px',
        cursor: 'pointer',
        [theme.breakpoints.down(1025)]: {
            height:'250px',
        },
        [theme.breakpoints.down(601)]: {
            height:'150px',
        },
    },
    slide1:{
        position:'relative', 
    },
    slide1Text:{
        position:'absolute', 
        top:'50%', 
        left:'33.2%',
        transform:'translate(-50%, -50%)',

        [theme.breakpoints.down(601)]: {
            display:'none'
        },
    },
    slide2:{
        position:'relative', 
    },
    slide2Text:{
        position:'absolute', 
        top:'50%', 
        left:'33.2%',
        transform:'translate(-50%, -50%)',

        [theme.breakpoints.down(601)]: {
            display:'none'
        },
    },
    slide3:{
        position:'relative', 
    },
    slide3Text:{
        position:'absolute', 
        top:'50%', 
        left:'33.2%',
        transform:'translate(-50%, -50%)',

        [theme.breakpoints.down(601)]: {
            display:'none'
        },
    },
    slide4:{
        position:'relative', 
    },
    slide4Text:{
        position:'absolute', 
        top:'50%', 
        left:'33.2%',
        transform:'translate(-50%, -50%)',

        [theme.breakpoints.down(601)]: {
            display:'none'
        },
    },
    slideTextSpan:{
        color:'#CBC9A2',
        letterSpacing: '-2px',
        fontSize:'40px',
    },
    slideTextH1:{
        color:'#201E05',
        fontSize:'35px',

        [theme.breakpoints.down(873)]: {
            fontSize:'24px',
        },
    },
    arrowRight:{
        position:'absolute', 
        top: '40%',
        right:'50px',
        fontSize:'50px', 
        color:'#FFFFFFCC', 
        zIndex:'9',
        [theme.breakpoints.down(1025)]: {
            top: 100,
            right: 20,
        },
        [theme.breakpoints.down(601)]: {
            top: 50,        
        },
    },
    arrowLeft:{
        position:'absolute', 
        top: '35%', 
        left:'50px',
        transform:'translateY(50%)', 
        fontSize:'50px', 
        color:'#FFFFFFCC', 
        zIndex:'9', 
        [theme.breakpoints.down(1025)]: {
            top: 80,
            left: 20,
        },
        [theme.breakpoints.down(601)]: {
            top: 30,        
        },
    },
    article2:{
    },
    textDiv:{
        paddingTop:'50px',
    },
    textDivH1:{
        color:'#232323',
        fontWeight:'600',
        fontSize:'25px',
        letterSpacing: '-1.6px',
        margin:'0 20px 20px 0',

        fontFamily:[
            'Noto Sans KR'
        ],

        [theme.breakpoints.down(1025)]: {
            fontSize:'24px',
        },
        [theme.breakpoints.down(281)]: {
            fontSize:'18px',
        },
    },
    greenStrong:{
        color:'#007235',
        padding:'0 5px',
    },
    textDivSpan:{
        color:'#FF4630',
        letterSpacing: '-0.8px',
        borderRadius:'31px',
        padding:'5px 10px',
        background:'#FFFFFF',
        boxShadow: '0px 2px 3px #D5D5D5',
        fontWeight:'600',
        fontSize:'14px',
        [theme.breakpoints.down(357)]: {
            display:'none'
        },

        fontFamily:[
            'Noto Sans KR'
        ],
    },
    wantSpan:{
        color:'#555',
        fontSize:'15px',
        display:'block',
        letterSpacing: '-0.8px',
        padding:'5px 0 0 0',

        fontFamily:[
            'Noto Sans KR'
        ],
        [theme.breakpoints.down(410)]: {
            fontSize:'13px',
        },
    },
    colorBox:{
        display:'flex',
        padding:'15px 0 50px 0',
        width: '100%',
        flexWrap: 'wrap'
    },
    moreBtnDiv:{
        textAlign:'center',
        margin:'100px 0'
    },
    moreBtn:{
        color:'#fff',
        background:'#007235',
        borderRadius: '37px',
        width:'300px',
        height:'65px',
        fontSize:'25px',
        [theme.breakpoints.down(769)]: {
            width:'180px',
            fontSize:'18px',
        },
    },
    article3:{
        background:'#F7FBF2',
        paddingBottom:'100px',
        maxWidth: 1920,
        margin: '0px auto'
    },
    ShopList: props => ({
        maxWidth: props.maxWidth,
        margin:'0 auto', 
        padding:'10px 0px 0px 0px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',

        fontFamily:[
            'Noto Sans KR'
        ],
    }),
    imgDiv: props => ({
        paddingTop:'50px',
        maxWidth: props.maxWidth,
        display: 'grid',
        gridTemplateColumns: `repeat(5, 1fr)`,
        gridColumnGap: props.columGap,
        gridRowGap: props.rowGap,
        [theme.breakpoints.down(1025)]: {
            placeItems: 'center',
            gridTemplateColumns: `repeat(2, 1fr)`,
            gridColumnGap: props.columGapMobile,
            gridRowGap: props.rowGap,
        },
        [theme.breakpoints.down(350)]: {
            placeItems: 'center',
            gridTemplateColumns: `repeat(1, 1fr)`,
            gridColumnGap: props.columGapMobile,
            gridRowGap: props.rowGap,
        }
    }),
    imgList:{
        cursor: 'pointer',
        width:'200px',
        height:'200px',
        borderRadius: 5,
        '&:hover':{
            boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'
        },
        [theme.breakpoints.down(1025)]: {
            width:'180px',
            height:'180px',  
            padding:'0 5px 0 0',         
        },
        [theme.breakpoints.down(371)]: {
            width: '130px',
            height: '130px',
        }
    },
    imgMapDiv:{
        display: 'flex',
        flexDirection: 'column',
        justifyContent:'center',
        paddingBottom:'15px',
    },
    imgListTextH1:{
        color:'#232323',
        letterSpacing: '-1.2px',
        fontSize:'17px',
        padding:'3px 0',
        [theme.breakpoints.down(394)]: {
            fontSize:'14px',
        },
        [theme.breakpoints.down(361)]: {
            fontSize:'12px',
        },

        fontFamily:[
            'Noto Sans KR'
        ],
    },
    imgListTextNameP:{
        color:'#808080',
        letterSpacing: '-0.8px',
        fontSize:'14px',
        paddingBottom:'3px',
        [theme.breakpoints.down(394)]: {
            fontSize:'12px',
        },

        fontFamily:[
            'Noto Sans KR'
        ],
    },
    priceFlex:{
        display:'flex',
        alignItems:'center',
    },
    imgListTextSalePriceP:{
        color:'#808080',
        letterSpacing: '-0.8px',
        textDecorationLine: 'line-through',
        fontSize:'13px',

        fontFamily:[
            'Noto Sans KR'
        ],
    },
    imgListTextPriceP:{
        color:'#232323',
        letterSpacing: '-1px',
        fontWeight:'600',
        [theme.breakpoints.down(371)]: {
            fontSize:'14px',
        },

        fontFamily:[
            'Noto Sans KR'
        ],

    },
    article4:{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    article4Img:{
        position:'relative',
    },
    article4SpanDiv:{
        position:'absolute',
        top:'50%',
        left:'50%',
        transform:'translate(-50%, -50%)',
        textAlign:'center',
        [theme.breakpoints.down(617)]: {
            position: 'static',
            top:'0',
            left:'0',
            transform:'translate(0%, 0%)',
            border:'1px solid #F1E8FE ',
            background:'#F1E8FE'
        },
    },
    article4span:{
        display:'block',
        fontWeight:'800',
        color:'#232323',
        background:'#F1E8FE',
        fontSize:'20px',
        [theme.breakpoints.down(770)]: {
            fontSize:'16px',
        },

        fontFamily:[
            'Noto Sans KR'
        ],
    },
    article5:{
        background:'#F1E8FE',
        maxWidth: 1920,
        margin: '0px auto',
        [theme.breakpoints.down(1025)]: {
        },
    },
    imgFlexDiv:{
        paddingTop:'80px',
        display:'flex',
        justifyContent:'space-evenly',

        [theme.breakpoints.down(1025)]: {
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        },
    },
    leftimg:{
        position:'relative',
        backgroundImage:`url(/images/left_main.png)`,
        backgroundSize:'contain',
        backgroundRepeat:'no-repeat',
        width:'500px',
        height:'300px',

        [theme.breakpoints.down(491)]: {
            width:'370px'
        },

        [theme.breakpoints.down(376)]: {
            width:'340px'
        },

        [theme.breakpoints.down(340)]: {
            width:'280px'
        },
    },
    leftSpan:{
        color:'#fff',
        fontWeight:'600',
        fontSize:'1.4em',
        letterSpacing: '-1.3px',
        position:'absolute',
        top:'120px',
        left:'33%',
        transform:'translate(-50%, -50%)',

        [theme.breakpoints.down(491)]: {
            fontSize:'1.1em',
            top:'100px',
        },

        [theme.breakpoints.down(340)]: {
            fontSize:'0.9em',
            top:'90px',
        },

        fontFamily:[
            'Noto Sans KR'
        ],
    },
    rightimg:{
        position:'relative',
        backgroundImage:`url(/images/right_main.png)`,
        backgroundSize:'contain',
        backgroundRepeat:'no-repeat',
        width:'500px',
        height:'300px',

        [theme.breakpoints.down(491)]: {
            width:'370px'
        },

        [theme.breakpoints.down(376)]: {
            width:'340px'
        },

        [theme.breakpoints.down(340)]: {
            width:'280px'
        },
    },
    rightSpan:{
        color:'#232323',
        fontWeight:'600',
        fontSize:'1.4em',
        letterSpacing: '-1.3px',
        position:'absolute',
        top:'120px',
        left:'27%',
        transform:'translate(-50%, -50%)',
        display:'flex',
        flexDirection: 'column',

        [theme.breakpoints.down(491)]: {
            fontSize:'1.2em',
            top:'100px',
        },
        [theme.breakpoints.down(340)]: {
            top:'90px',
        },

        fontFamily:[
            'Noto Sans KR'
        ],
    },
    rightSpanLastSpan:{
        letterSpacing: '0',
        fontSize:'33px',

        [theme.breakpoints.down(491)]: {
            fontSize:'1.2em',
        },

        [theme.breakpoints.down(340)]: {
            fontSize:'1em',
        },

        fontFamily:[
            'Noto Sans KR'
        ],
    },
    allProductFirstTextDiv:{
        display:'flex',
        alignItems: 'baseline'
    },
    firstTextDivIcon:{
        fontSize:'25px',
        alignSelf: 'center'
    },
    article6:{
        background:'#FFF1E4',
        paddingBottom:'100px',
        maxWidth: 1920,
        margin: '0px auto'
    },
    flowerDiv:{
        position:'relative',
        paddingBottom:'100px',
        [theme.breakpoints.down(1025)]: {
            paddingBottom:'30px',
        },
    },
    flowerImg:{
        position:'absolute',
        right:'0',
        top:'-200px',
        [theme.breakpoints.down(1025)]: {
            display:'none'
        },
    },
    boxDiv:{
        display:'flex',
        flexWrap:'wrap',
        justifyContent:'space-between',
        [theme.breakpoints.down(1116)]: {
            justifyContent:'center'
        },
    },
    article6flexDiv:{
        display:'flex',
        flexWrap:'wrap',
        marginBottom:'20px',
        borderRadius: 20,
        boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
        [theme.breakpoints.down(769)]: {
            width:'180px', 
            height:'180px',
            margin: 5
        },
    },
    recoImg:{
        width:'180px', 
        height:'180px',
        borderRadius: '20px 0 0 20px',
        [theme.breakpoints.down(769)]: {
            borderRadius: '20px',
        },        
    },
    spanDiv:{
        background:'#fff',
        width:'370px',
        position:'relative',
        color:'#232323',
        letterSpacing: '-1px',
        borderRadius: '0 20px 20px 0',
        fontFamily:[
            'Noto Sans KR'
        ],
        [theme.breakpoints.down(769)]: {
            display: 'none'
        },

    },
    content:{
        padding:'10px'
    },
    date:{
        position:'absolute',
        right:'0',
        bottom:'0',
        padding:'10px'
    },
    article7:{
    },
    instaDiv:{
        padding:'15px 0'
    },
    instaDivImg:{
        paddingRight:'10px'
    },
    ShopList: props => ({
        maxWidth: props.maxWidth,
        margin:'0 auto', 
        padding:'10px 0px 0px 0px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        [theme.breakpoints.down(1025)]: {
            alignItems: 'center',
        },
        fontFamily:[
            'Noto Sans KR'
        ],
    }),
    itemDiv:{
        display:'flex',

        [theme.breakpoints.down(1025)]: {
            flexDirection:'column'
        }

    },
    bestItemDiv: props => ({
        maxWidth: props.maxWidth,
        display: 'grid',
        gridTemplateColumns: `repeat(${props.colums}, 1fr)`,
        gridColumnGap: props.columGap,
        gridRowGap: props.rowGap,
        placeItems: 'center',
        [theme.breakpoints.down('sm')]: { //600px
        gridTemplateColumns: `repeat(${props.columsMobile}, 1fr)`,
        gridColumnGap: props.columGapMobile,
        gridRowGap: props.rowGap,
        },

        [theme.breakpoints.down(1025)]: {
            display:'none',
        }
    }),
    resultItemDiv: props => ({
        maxWidth: props.maxWidth,
        display: 'grid',
        gridTemplateColumns: `repeat(4, 1fr)`,
        gridColumnGap: props.columGap,
        gridRowGap: props.rowGap,
        [theme.breakpoints.down(1025)]: {
            placeItems: 'center',
            gridTemplateColumns: `repeat(2, 1fr)`,
            gridColumnGap: props.columGapMobile,
        },
        [theme.breakpoints.down(350)]: {
            gridTemplateColumns: `repeat(1, 1fr)`,
        }
    }),


}));

const Home = () => {
    const [dialog, setDialog] = useState('');
    const [popUps, setPopUps] = useState([]);
    
    // 이전방문 날짜
    const beforeVisit = localStorage.getItem('VisitCookie')
    // 현재 날짜
    const nowDate = Math.floor(new Date().getDate())

    useEffect(() => {
        // 팝업 오늘 하루닫기 체크
        if (beforeVisit !== null) {
            // 날짜가 같을경우 비노출
            if (parseInt(beforeVisit) === nowDate) {
                setPopUps([])
            }
        }
    }, [beforeVisit])

    useEffect(() => {
        if (parseInt(beforeVisit) !== nowDate) {
            getData()
        }
        
    }, [])

    const getData = async() => {
        try{
            const res = await axios.post('/api/adm/getPopup/')
            if(res.data.success === false) {
                return ;
            }
        
            const resData = res.data.result
            
            setPopUps(resData)
        }catch(e){
            console.log(e)
        }
    }

    const dayClose = () =>{
        const expiry = new Date()
        const expiryDate = expiry.getDate()
        // 로컬스토리지 저장
        localStorage.setItem('VisitCookie', expiryDate)
        setPopUps([])
    }

    return(
        <div>
            <Section1 setDialog={setDialog} />
            <Section2
                setDialog={setDialog}     
            />
            <Section3 />
            <Section4 />
            <Section5 />
            <Section6 />
            {/* <Section7 /> */}
            {popUps.length > 0 && (
                <Popup 
                    popUps={popUps} 
                    setPopUps={setPopUps}
                    dayClose={dayClose}
                />
            )}

            <Dialog
                open={dialog === '' ? false : true}
                onClose={() => setDialog('')}
            >
                <DialogTitle id="alert-dialog-title">
                    {dialog}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={() => setDialog('')} autoFocus>
                        확인
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
        
    )
}

const Section1 = ({setDialog}) => {
    let navigate = useNavigate();
    const login = useSelector(state => state.user.login);
    const theme = useTheme();
    const classes = useStyles(theme);
    const [data, setData] = useState([])

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [data])
    

    const getData = async() => {
        try{
            const res = await axios.post('/api/adm/getSliders/')
            if(res.data.success === false) {
                return ;
            }
        
            const resData = res.data.result
        
            setData(resData)
        }catch(e){
            console.log(e)
        }
    }

    useEffect(() => {
        getData()
    }, [])


    const settings1 = {
        dots : false,
        autoplay : true,
        autoplaySpeed : 5000,
        slidesToShow : 1,
        slidesToScroll : 1, 
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    infinite: true,
                    dots: false,
                    arrows: true
                }
            },
        ]
    };

    return(
        <div className={classes.mainSectionBlock}>
            <div className={classes.article1}>
                <Slider {...settings1} className={classes.slide}>
                    {data.length >0 && data.map( (result, index) => {
                        return(
                            <div key={index}>
                                <img 
                                    src={`${mainPath}/media/data/slider/${result['slider_img']}`}
                                    className={classes.slideImg}
                                    onClick={() => {
                                        if(!login) return setDialog('로그인후 이용 가능 합니다.')
                                        let urlList = result['slider_url'].split(',')
                                        if(urlList[0] === '공지'){
                                            if(!urlList[1]) return
                                            navigate('/BoardLook', {
                                                state:{ id: parseInt(urlList[1]),  cateType: 'notice'}
                                            })
                                        } else if (urlList[0] === '상품') {
                                            if(!urlList[1]) return
                                            navigate("/ShopMain/ShopItem", {
                                                state: { itId: urlList[1] }
                                            });
                                        } else if (urlList[0] === '상품목록') {
                                            if(!urlList[1]) return
                                            navigate('/ShopMain/ShopList', {
                                                state: { caId: urlList[1] }
                                            })
                                        }
                                    }}
                                />
                            </div>
                        )
                    }
                    )}                   
                </Slider>
            </div>
        </div>
    )
}

const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;

    const theme = useTheme();
    const classes = useStyles(theme);

    return (
        <IoIosArrowDroprightCircle className={classes.arrowRight} onClick={onClick} />
    );
}

const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;

    const theme = useTheme();
    const classes = useStyles(theme);

    return (
        <IoIosArrowDropleftCircle className={classes.arrowLeft} onClick={onClick}/>
    );
}


const Section2 = ({
    setDialog,
    imageWidth=270, 
    imageHeight=270, 
    imageWidthMobile=160, 
    imageHeightMobile=160, 
    }) => {
    
    const theme = useTheme();
    const classes = useStyles(theme);
    const dispatch = useDispatch()
    const [colorId, setColorId] = useState(2);
    const [colorList, setColorList] = useState([]);
    const [bestItem, setBestItem] = useState();
    const [resultItem, setResultItem] = useState([]);
    let navigate = useNavigate();



    const getColorsItems = useCallback(async() => {
        try {
            const res = await axios.post('/api/shop/shopColors/')
            if(res.data.success === false) {
                return;
            }

            setColorList(res.data.result)

        } catch (e) {
            console.log(e)
        }
    }, [])
    
    useEffect( () => {
        getColorsItems()
    }, [])



    const getColorItemMain = useCallback(async() => {
        try {
            const res = await axios.post('/api/shop/shopColorItemMain/', {color_id:colorId})
            if(res.data.success === false) {
                return;
            }

            setBestItem(res.data.bestItem)
            setResultItem(res.data.result)

        } catch (e) {
            console.log(e)
        }
    }, [colorId])

    useEffect( () => {
        getColorItemMain()
    }, [colorId])




    return(
        <div>
            <div className={classes.article2}>
                <div className={classes.row}>
                    <div className={classes.textDiv}>
                        <div className={classes.firstTextDiv}>
                            <span className={classes.textDivH1}> 
                                어떤 색상의 꽃을 찾으시나요? 
                            </span>
                        </div>
                        <span className={classes.wantSpan}>선택한 색상에 맞는 꽃을 추천해드립니다.</span>
                        <div className={classes.colorBox}>
                            {colorList.length > 0 && colorList.map((item) =>{
                                if (item['color_id'] === 1) return;
                                return(
                                    <ColorItem
                                        key={item['color_id']}
                                        colorCode={item['color_code']}
                                        colorIds={item['color_id']}
                                        setColorId={setColorId}
                                    />  
                                )
                            })}
                        </div>                   
                    </div> 
                    <div 
                        className={classes.itemDiv}
                    >
                        <div className={classes.bestItemDiv}>
                            {bestItem && bestItem['it_id']  &&                             
                                    <BestItem 
                                        BitHit={bestItem['it_hit']}
                                        BitId={bestItem['it_id']}
                                        BitImg1={bestItem['it_img1']}
                                        BitName={bestItem['it_name']}
                                        BitPrice={bestItem['it_price']}
                                        BitType1={bestItem['it_type1']}
                                        BitType2={bestItem['it_type2']}
                                        BitType3={bestItem['it_type3']}
                                        BitType4={bestItem['it_type4']}
                                        BitType5={bestItem['it_type5']}
                                        setDialog={setDialog}
                                    />
                                
                            }
                        </div>
                        <div className={classes.ShopList}>
                            <div className={classes.resultItemDiv}>
                                {resultItem.length > 0 && resultItem.map((item) => {
                                    return(
                                        <ResultItem 
                                            key={item['it_id']}
                                            itHit={item['it_hit']}
                                            itId={item['it_id']}
                                            itImg1={item['it_img1']}
                                            itName={item['it_name']}
                                            itPrice={item['it_price']}
                                            itType1={item['it_type1']}
                                            itType2={item['it_type2']}
                                            itType3={item['it_type3']}
                                            itType4={item['it_type4']}
                                            itType5={item['it_type5']}
                                            itStockQty={item['it_stock_qty']}
                                            imageWidth={imageWidth} 
                                            imageHeight={imageHeight} 
                                            imageWidthMobile={imageWidthMobile}
                                            imageHeightMobile={imageHeightMobile}
                                            setDialog={setDialog}
                                        />
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    <div className={classes.moreBtnDiv}>
                        <button 
                            className={classes.moreBtn}
                            onClick={() => {
                                dispatch(setOrderAll('1'))
                                dispatch(setPageAll(1))
                                dispatch(setColorAll(2))
                                navigate("/ShopMain/ShopColorSearch")
                            }}
                        >
                            VIEW MORE +
                        </button>
                    </div>
                </div>
                
            </div>
        </div>
    )
    
}

const useColorItemStyles = makeStyles((theme)=>({

    itemBox: props => ({
        width:'35px',
        height:'35px',
        margin:'0 5px',
        '&:hover':{
            border:'3px solid #000'
        },
        boxShadow: '0px 3px 6px #00000029',
        background: props.colorCode,
        [theme.breakpoints.down(769)]: {
            marginBottom: 5
        },
    }),

}))

const ColorItem = ({
    colorCode, 
    colorIds,
    setColorId
    }) => {

    const theme = useTheme();
    let editTheme = {...theme, colorCode}
    const classes = useColorItemStyles(editTheme);

    return(
        <div 
            className={classes.itemBox}
            onClick={() => setColorId(colorIds)}
        >
        </div>
    )
    
};

const useBestItemStyles = makeStyles((theme)=>({

    bestItemBox: {
        cursor: 'pointer',
        padding:'10px 0',
        position:'relative',
        width: '414px',
        height: '433px',
        
    },
    ItemImg: props =>({
        width: '100%',
        height: '100%',
        position:'absolute',
        top: 0,
        left: 0,
        [theme.breakpoints.down(1025)]: {
            width: props.imageWidthMobile,
            height: props.imageHeightMobile,
        },
        [theme.breakpoints.down(281)]: {
            width: '130px',
            height: '130px',
        }
    }),
    bestItemTextBox: props => ({
        position:'absolute',
        top:'88%',
        left:'50px',

        [theme.breakpoints.down(1025)]: {
            width: props.imageWidthMobile,
            top:'43%',
        },

        [theme.breakpoints.down(281)]: {
            width: '130px',
            height: '130px',
        }
    }),
    bestItemTextBoxP:{
        color:'#232323',
        fontWeight:'700',
        fontSize:'20px',
        letterSpacing: '-1.4px',

        fontFamily:[
            'Noto Sans KR'
        ],
    },

}))

const BestItem = ({
    BitId,
    BitImg1,
    BitName,
    imageWidth, 
    imageHeight, 
    imageWidthMobile, 
    imageHeightMobile,
    setDialog,
    }) => {

    const theme = useTheme();
    let editTheme = {...theme, imageWidth, imageHeight, imageWidthMobile, imageHeightMobile}
    const classes = useBestItemStyles(editTheme);
    const login = useSelector(state => state.user.login);
    let navigate = useNavigate();

    const goToItemDetail = () => {
        if(!login) return setDialog('로그인후 이용 가능합니다.')
        navigate("/ShopMain/ShopItem", {
            state: { itId: BitId }
        });
    }


    return(
        <div className={classes.bestItemBox} onClick={goToItemDetail}>
            <div className={classes.ItemImg}>
                <img 
                    style={{width: '100%', height: '100%', borderRadius: 10,}}
                    src={`${mainPath}/media/data/item/${BitImg1}`} 
                />
            </div>
            <div className={classes.bestItemTextBox}>
                <p className={classes.bestItemTextBoxP}>{BitName}</p>
            </div>

        </div>
    )
    
};

const useResultItemStyles = makeStyles((theme)=>({

    resultItemBox: {
        flexDirection: 'column',
        alignItems: 'center',
        cursor: 'pointer',
        padding:'10px',
        [theme.breakpoints.down(1025)]: {
            padding:'0px 10px 0 0',
        },
    },
    ItemImg: props =>({
        width: '150px',
        height: '150px',
        position: 'relative',

        [theme.breakpoints.down(1025)]: {
            width: props.imageWidthMobile,
            height: props.imageHeightMobile,
        },
        [theme.breakpoints.down(281)]: {
            width: '130px',
            height: '130px',
        }
    }),
    ItemTextBox: props => ({
        width: '100%',        

        [theme.breakpoints.down(1025)]: {
            width: props.imageWidthMobile,
        },

        [theme.breakpoints.down(281)]: {
            width: '130px',
            height: '130px',
        }
    }),
    ItemTypeBox: {
        display: 'flex',
    },
    ItemTextBoxP:{
        borderBottom:'1px solid #ccc',
        padding:'5px 0',
        color:'#232323',
        fontWeight:'700',
        fontSize:'13px',
        letterSpacing: '-0.85px',

        fontFamily:[
            'Noto Sans KR'
        ],
    },
    ItemTextBoxH1:{
        color:'#666666',
        fontSize:'12px',
        letterSpacing: '-0.7px',
        borderBottom:'1px solid #ccc',
        padding:'2px 0',

        fontFamily:[
            'Noto Sans KR'
        ],
    },
    floatingCart: {
        position: 'absolute',
        bottom: '2%',
        right: '2%',
        width:'35px',
        height:'35px',
    },
    ItemImgin: {
        width: '100%', 
        height: '100%',
        borderRadius: 5,
        transition: 'transform .4s',
        '&:hover':{
            transform: 'scale(1.02)'
        },
    }

}))

const ResultItem = ({
    itId,
    itImg1,
    itName,
    itPrice,
    itStockQty,
    imageWidth, 
    imageHeight, 
    imageWidthMobile, 
    imageHeightMobile,
    setDialog,
    }) => {

    const theme = useTheme();
    let editTheme = {...theme, imageWidth, imageHeight, imageWidthMobile, imageHeightMobile}
    const classes = useResultItemStyles(editTheme);
    const login = useSelector(state => state.user.login);
    const mbId = useSelector(state => state.user.userInfo['mb_id']);
    let navigate = useNavigate();

    const goToItemDetail = () => {
        if(!login) return setDialog('로그인후 이용 가능합니다.')
        navigate("/ShopMain/ShopItem", {
            state: { itId: itId }
        });
    }

    const addCart = async() => {
        if (!login) return alert('로그인후 이용 해주세요.')
        if (itStockQty === 0) return alert('품절된 상품 입니다.')
    
        let ip = ''
        let cartItems =[]
    
        try {
          const res = await axios.post('/api/shop/getCart/', {mb_id: mbId})
          if(res.data.success === false) {
            alert('실패하였습니다.')
            return
          }
          
          res.data.result.forEach(itm => {
            cartItems.push(itm.it_id)
          })
    
      
        } catch (e) {
          console.log(e)
        }
    
        if (cartItems.includes(itId)) return alert('이미 카트에 존재하는 상품입니다.')
    
    
        // try {
        //   const response = await axios.get('https://api.ipify.org?format=json');
        //   ip = response.data.ip;
        // } catch (error) {
        //   console.error(error);
        //   return
        // }
    
    
        try {
            const res = await axios.post(
              '/api/shop/addCart/', 
              {
                mb_id: mbId,
                it_id: itId,
                ct_qty: 1,
                ct_ip: ip,
              }
            )
    
            if(res.data.success === false) {
                alert('실패하였습니다.')
                return
            }
    
            alert('카트에 추가 되었습니다.')
    
          } catch (e) {
            console.log(e)
          }
      }

    return(
        <div className={classes.resultItemBox}>
            <div className={classes.ItemImg}>
                <img 
                    className={classes.ItemImgin}
                    src={`${mainPath}/media/data/item/${itImg1}`} 
                    onClick={goToItemDetail}
                />
                <div 
                    className={classes.floatingCart}
                    onClick={addCart}
                >
                    <img src='/images/cart_btn.png'  alt='장바구니'/>
                </div>
            </div>
            <div 
                className={classes.ItemTextBox}
                onClick={goToItemDetail}
            >
                <p className={classes.ItemTextBoxP}>{itName}</p>
                <h1 className={classes.ItemTextBoxH1}>{login ? `${itPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 원`: '회원 공개'}</h1>
            </div>
        
    
        </div>
    
    ) 
    
};

const Section3 = () => {

    const theme = useTheme();
    const classes = useStyles(theme);
    const login = useSelector(state => state.user.login);
    let navigate = useNavigate();

    const [data, setdata] = useState([]);
    const [dialog, setDialog] = useState('');
    const [dataBox, setdataBox] = useState({});
    const [itCustPrice, setitCustPrice] = useState('')


    const getData = async() => {

        try{
            const res = await axios.post('/api/shop/shopItemSlider/')
            if(res.data.success === false) {
                return ;
            }
        
            const resData = res.data.result
        
            setdata(resData)
            setdataBox(res.data.cateList.reduce((result, item) => Object.assign(result, {[item['ca_id']]: item['ca_name']}), {}))
            setitCustPrice(resData['it_cust_price'])

        }catch(e){
            console.log(e)
        }
    }

    const goToItemDetail = (id) => {
        if(!login) return setDialog('로그인후 이용 가능합니다.')
        navigate("/ShopMain/ShopItem", {
            state: { itId: id }
        });
    }

    useEffect(() => {
        getData()
    }, [])

    return(
        <div>
            <div className={classes.article3}>
                <div className={classes.row}>
                    <div className={classes.textDiv}>
                        <div className={classes.firstTextDiv}>
                            <span className={classes.textDivH1}> 
                                생초플라워의 
                                <strong className={classes.greenStrong}>
                                    신선한
                                </strong> 
                                250여종 꽃
                            </span>
                        </div>
                        <span className={classes.wantSpan}>
                            전국의 모든 꽃 사업주님들을 위한 신선한 플라워가 준비되어있습니다.
                        </span>
                    </div>
                    <div className={classes.ShopList}>
                        <div className={classes.imgDiv}>
                            {data.length > 0 && data.map((result, index) => {
                                return(
                                    <div 
                                        key={index}
                                        className={classes.imgMapDiv} 
                                        onClick={() => goToItemDetail(result['it_id'])}
                                    >                                    
                                        <img 
                                            src={`${mainPath}/media/data/item/${result['it_img1']}`}  
                                            className={classes.imgList}
                                        />
                                        <div className={classes.imgListTextDiv} style={{cursor: 'pointer'}}>
                                            <h1 className={classes.imgListTextH1}>
                                                {result['it_name']}
                                            </h1>
                                            <p className={classes.imgListTextNameP}>
                                                {dataBox[result['ca_id2']]}
                                            </p>
                                            <div className={classes.priceFlex}>
                                                <p className={classes.imgListTextPriceP}>
                                                    {login ? result['it_price'] && `${result['it_price'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 원` : '회원 공개'}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    
                    
                </div>
                <Dialog
                    open={dialog === '' ? false : true}
                    onClose={() => setDialog('')}
                >
                    <DialogTitle id="alert-dialog-title">
                        {dialog}
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={() => setDialog('')} autoFocus>
                            확인
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    )

}


const Section4 = () => {

    const theme = useTheme();
    const classes = useStyles(theme);

    return(
        <div>
            <div className={classes.article4}>
                <div className={classes.article4Img}>
                    <img src='/images/LAVENDA.png'/>
                    <div className={classes.article4SpanDiv}>
                        <span className={classes.article4span}>매일 아침 사장님들께서</span> 
                        <span className={classes.article4span}>가장 신선한 꽃을 받으실 수 있도록</span> 
                        <span className={classes.article4span}>최선을 다하는 '생초 플라워'가 되겠습니다.</span>
                    </div>
                </div>
            </div>
        </div>
    )

}

const Section5 = () => {

    const theme = useTheme();
    const classes = useStyles(theme);
    const shopInfoTel = useSelector(state => state.config.shopDefaultConfig.de_admin_company_tel)

    return(
        <div>
            <div className={classes.article5}>
                <div className={classes.row}>
                    <div className={classes.imgFlexDiv}>
                        <div 
                            className={classes.leftimg}
                        >
                            <span className={classes.leftSpan}>
                                각 지역별 담당 꽃 전문가가<br/>
                                추천하는 상품을 만나보세요
                            </span>
                        </div>
                        <div 
                            className={classes.rightimg}
                        >
                            <span className={classes.rightSpan}>
                                <span>고객센터</span>
                                <span className={classes.rightSpanLastSpan}>{shopInfoTel}</span>
                            </span>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
    )

}

const Section6 = () => {

    const theme = useTheme();
    const classes = useStyles(theme);

    const [data, setData] = useState([])

    const getData = async() => {
        try{
          const res = await axios.post('/api/shop/shopRecomandsMain/')
          if(res.data.success === false) {
            return ;
          }
    
          const resData = res.data.result
    
          setData(resData)
    
        }catch(e){
          console.log(e)
        }
    }

    useEffect(() => {
        getData()
    }, [])

    return(
        <div>
            <div className={classes.article6}>
                <div className={classes.row}>
                    <div className={classes.textDiv}>
                        <div className={classes.allProductFirstTextDiv}>
                            <span className={classes.textDivH1}> 
                                김기태 팀장님이 추천해요!
                            </span>
                            <span className={classes.textDivSpan}>
                                추천!
                            </span>
                        </div>                        
                    </div> 
                    <div className={classes.flowerDiv}>
                        <img className={classes.flowerImg} src='/images/flowers.png' alt='꽃' />
                    </div>
                    <div className={classes.boxDiv}>
                        {data.length > 0 && data.map((result, idx) => {
                            return( 
                                    <div 
                                        key={idx}
                                        className={classes.article6flexDiv}
                                    >
                                        <img 
                                            src={`${mainPath}/media/data/recomand/${result['reco_img']}`}  
                                            alt='' 
                                            className={classes.recoImg}
                                        />
                                        <div className={classes.spanDiv}>
                                            <div className={classes.content}>
                                                <span>
                                                    {result['reco_cont']}
                                                </span>
                                            </div>
                                            <div className={classes.date}>
                                                <span>
                                                    {result['reco_date']}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                
                            )
                        }
                        )}
                    </div>
                </div>
            </div>
        </div>
    )

}

const Section7 = () => {

    const theme = useTheme();
    const classes = useStyles(theme);

    const [instaId, setInstaId] = useState('')
    const [instaToken, setInstaToken] = useState()
    

    const getData = async() => {
        try{
          const res = await axios.get('/api/adm/configInstaView/')
          if(res.data.success === false) {
            return ;
          }
    
          const resData = res.data.result

    
          setInstaId(resData.cf_syndi_token)
          setInstaToken(resData.cf_syndi_except)
    
        }catch(e){
          console.log(e)
        }
    }

    useEffect(() => {
        getData()
    }, [])

    return(
        <div>
            <div className={classes.article7}>
                <div className={classes.row}>
                    <div className={classes.textDiv}>
                        <div className={classes.allProductFirstTextDiv}>
                            <span className={classes.textDivH1}> 
                                인스타그램
                            </span>
                            <div>
                                <IoIosArrowForward className={classes.firstTextDivIcon}/>
                            </div>
                        </div>
                        <span className={classes.wantSpan}>
                            생초플라워의 더 많은 게시물 보러가기         
                        </span>

                        <div className={classes.instaDiv}>
                            <img src='/images/insta_logo.png' alt='인스타그램' className={classes.instaDivImg} />
                            <span className={classes.instaDivSpan}>@{instaId && instaId}</span>
                        </div>
                        {instaToken && (
                            <InstagramFeed 
                                token={instaToken}  
                                counter="8"
                            />  
                        )}

                    </div> 
                </div>
            </div>
        </div>
    )

}



export default Home;